import { Col, Row } from "react-bootstrap"

const RRBuild = () =>{
    
    return <> <h1>How to build Raspberry Ripples</h1>
      
    <p>Raspberry Ripples has 2 PCBs: the motherboard, and the interface. All SMD parts are pre-soldered, all you have to do is solder the remaining thrugh hole parts.</p>
    
    <p>N.B. the original interface boards require some additional common through hole parts which you will definitley have</p>

    {/* <p>The <a href = "/#CAV/ibom.html" target="_parent">BOM</a> describes the solder-able components you will need.</p> */}

    <p>The full list of required components, if you can botch it, and any notes:</p>
    <table>
        <tr>
        <th>Name </th>
        <th>Quantity </th>
        <th>Mandatory </th>
        <th>Source </th>
        <th>Details </th>
        </tr>
        <tr>
          <td>Mono 3.5mm Jacks (thonkiconn)</td>
          <td>10</td>
          <td>Yes</td>
          <td>
          <a href="https://www.taydaelectronics.com/pj-3001f-3-5-mm-mono-phone-jack.html">Tayda: PJ-3001F</a><br/>
          <a href="https://www.thonk.co.uk/shop/thonkiconn/">Thonk: Thonkiconn PJ398SM</a>
          </td>
          <td>The ones just about everyone already uses</td>
        </tr>
        <tr>
          <td>Shrouded 2x5 pin header</td>
          <td>2 (1 for power, 1 for optional expander)</td>
          <td>Yes</td>
          <td>
            <a href = "https://www.thonk.co.uk/shop/eurorack-diy-essentials/">Thonk</a><br/>
            <a href = "https://www.taydaelectronics.com/10-pin-box-header-connector-2-54mm.html">Tayda</a>
          </td>
          <td>Can use unshrouded pins if you live fast and loose</td>
        </tr>
        <tr>
          <td>100k Alpha 9mm potentiometer</td>
          <td>4</td>
          <td>Yes</td>
          <td>
            <a href = "https://www.thonk.co.uk/shop/alpha-9mm-pots-vertical-t18/?_gl=1*8jxscq*_up*MQ..*_gs*MQ..&gclid=CjwKCAjwtKrUBhAhEiwAr77Zok8cga6ExM-gRP2z091N84TZ4zVTMg3-aVv7KiXJ-IUk0J6-T-cmyhoCqeoQAvD_BwE">Thonk</a>
          </td>
          <td>
          linear taper
          </td>
        </tr>
        <tr>
          <td>M3 Screws</td>
          <td>4</td>
          <td>Yes</td>
          <td></td>
          <td>For binding PCBs</td>
        </tr>
        <tr>          
          <td>11mm M2 spacers</td>
          <td>2</td>
          <td>Yes</td>
          <td></td>
          <td>For binding PCBs, can botch with smaller spacers and washers</td>
        </tr>
        <tr>
          <td>12 pin 2.54mm box pin male headers</td>
          <td>1</td>
          <td>No</td>
          <td>
            <a href = "https://www.thonk.co.uk/shop/eurorack-diy-essentials/">Thonk</a> <br/>
            <a href = "https://www.taydaelectronics.com/12-pin-2-54-mm-single-row-pin-header-strip.html">Tayda</a>
          </td>
          <td>For connecting PCBs</td>
        </tr>
        <tr>
          <td>12 pin 2.54mm box pin female header</td>
          <td>1</td>
          <td>No</td>
          <td>
            <a href = "https://www.thonk.co.uk/shop/eurorack-diy-essentials/">Thonk</a> <br/>
            <a href = "https://www.taydaelectronics.com/12-pin-2-54-mm-single-row-female-pin-header-tayda.html">Tayda</a>
          </td>
          <td>For connecting PCBs</td>
        </tr>
        <tr>
          <td>7 pin 2.54mm box pin male headers</td>
          <td>1</td>
          <td>Yes</td>
          <td>
            <a href = "https://www.thonk.co.uk/shop/eurorack-diy-essentials/">Thonk</a> <br/>
            <a href = "https://www.taydaelectronics.com/12-pin-2-54-mm-single-row-pin-header-strip.html">Tayda</a>
          </td>
          <td>For connecting PCBs</td>
        </tr>
        <tr>
          <td>7 pin 2.54mm box pin female header</td>
          <td>1</td>
          <td>Yes</td>
          <td>
            <a href = "https://www.thonk.co.uk/shop/eurorack-diy-essentials/">Thonk</a> <br/>
            <a href = "https://www.taydaelectronics.com/12-pin-2-54-mm-single-row-female-pin-header-tayda.html">Tayda</a>
          </td>
          <td>For connecting PCBs</td>
        </tr>
        <tr>
          <td>DIP-16 SSI2164, V2164D, or AS2164</td>
          <td>1</td>
          <td>Yes</td>
          <td>
            <a href = "https://www.thonk.co.uk/shop/as2164/">Thonk</a> <br/>
            
          </td>
          <td>Tested working with as2164, no reason why others wouldn't work beyond slightly different gains at outputs</td>
        </tr>
       <tr>
          <td>16 pin DIP socket</td>
          <td>1</td>
          <td>No</td>
          <td>
            <a href = "https://www.thonk.co.uk/shop/eurorack-diy-essentials/">Thonk</a> <br/>
            <a href = "https://www.taydaelectronics.com/16-pin-dip-ic-socket-adaptor-solder-type.html">Tayda</a>
          </td>
          <td>Makes replacing the 2164 easier</td>
        </tr>
        <tr>
          <td>10k vertical trimmer</td>
          <td>2</td>
          <td>Yes</td>
          <td>
            <a href = "https://www.thonk.co.uk/shop/25-turn-trimmer-potentiometer/">Thonk</a> <br/>
            <a href = "https://www.taydaelectronics.com/10k-ohm-trimmer-potentiometer-cermet-25-turns-3296w.html">Tayda</a>
          </td>
          <td>For tuning V/Oct tracking and VCA gain</td>
        </tr>
        <tr>
          <td>If you have a classic interface:</td>
        </tr>
        <tr>
          <td>81k Resistor</td>
          <td>1</td>
          <td>Yes</td>
          <td>
          </td>
          <td>Resonance CV processing, does not need to be exact!</td>
        </tr>
        <tr>
          <td>100k Resistor</td>
          <td>3</td>
          <td>Yes</td>
          <td>
          </td>
          <td></td>
        </tr>
        <tr>
          <td>1k Resistor</td>
          <td>2</td>
          <td>Yes</td>
          <td></td>
          <td>LED current limiting, reduce for brighter LEDs at your own risk</td>
        </tr>
      </table>
      <br></br>
    <h2>Lets Go!</h2>
      <Col>
      <Row style={{}}>
    <Col style={{minWidth:"40rem"}}>
    <h4>Step 1:</h4>
    <p>Solder The 2 shrouded headers, 10k trimmers, and DIP socket to the main PCB.</p>
     <p>It's easier to solder in order of height and bending the pins of the socket/trimmers helps keep them in place</p>

    </Col> 
      <Col>
        <img src="/RaspberryRipplesDIY/step1_compressed.jpg" style={{height:"50vh"}}></img>
      </Col>
      
    </Row>
    <Row style={{margin:"4rem"}}></Row>
    
    <Row>

    <Col style={{minWidth:"20rem"}}>
    <h4>Step 2:</h4>
    <p>
       Solder The through hole components of the interface PCB.<br></br>
       <br></br>
       Start with resistors (2x100k, 1x81k, and 2x1k). <br></br>
       <br></br>
       then the 2 2n3904 transistors (if using altenerative NPN transistors please check the pins!!) <br></br>
       </p>
        <p>N.B., the first revision forgot to label the resistor in the upper right corner (Rint3) it is 1k.</p>
    </Col>
    <Col style={{minWidth:"20rem"}}>
      <img src="/RaspberryRipplesDIY/step2_1_compressed.jpg" style={{height:"50vh"}}></img>
    </Col>
    </Row>
        <Row style={{margin:"4rem"}}></Row>

    <Row>

    <Col style={{minWidth:"20rem"}}>
    <h4>Step 3:</h4>
      <p>Now let's do the headers which connect the boards.</p>
      <p>As access to the header solder points is obscured by the jacks we have to do this annoying step</p>
      <p>Use M3 bolts/nuts to attach the 2 11mm standoffs to the interface board</p>
      <p>Now connect the male and female header and place between the 2 boards. screw the PCB into the standoffs to keep the headers aligned and solder</p>

    </Col>
    <Col>
    <Col>
      <img src="/RaspberryRipplesDIY/step2_2_compressed.jpg" style={{width:"18rem"}}></img>
    </Col>
    <Col>
      <img src="/RaspberryRipplesDIY/step2_3_compressed.jpg" style={{width:"18rem"}}></img>
    </Col>
    <Col>
      <img src="/RaspberryRipplesDIY/step2_4_compressed.jpg" style={{width:"18rem"}}></img>
    </Col>
    </Col>
    </Row>
    <Row style={{margin:"4rem"}}></Row>
    
    <Row>
    <Col style={{minWidth:"20rem"}}>
    <h4>Step 4:</h4>
      <p>Disconnect the PCBs so we can finish the interface.</p>
      <p>Insert the 100k potentiometers and solder first to provide nice anchor points. </p>
      <p>Now use the faceplate to keep the mono jacks and LED in place whilst you solder. use a bit of tape to hold the LEDs at a height you like... or just push them all the way through</p>
      
      <p>You shouldn't need to take the faceplate off once this is done!</p>
          </Col>
      <Col style={{minWidth:"20rem"}}>
      <img src="/RaspberryRipplesDIY/step_3_compressed.jpg" style={{width:"14rem"}}></img>
      </Col>
    </Row>
    <Row style={{margin:"4rem"}}></Row>
    <Row>
    <Col style={{minWidth:"20rem"}}>
    <h4>Step 5:</h4>
    
      <p>insert the as2164 into your socket and Reconnect the boards.</p>
      <p>Double check everything then use your multimeter to make sure there are no shorts between either power rails and ground. 
        Other than that, Let's plug it in and see what happens.</p>
    </Col>
      
      <Col style={{minWidth:"20rem"}}>
      <img src="/RaspberryRipplesDIY/step_5.jpg" style={{height:"20rem"}}></img>
      <p>Beautiful</p>
      </Col>
    </Row>
    
    <Row style={{margin:"4rem"}}></Row>
    <Row>
    <Col style={{maxWidth:"40rem"}}>
    <h4>Step 6 - Tuning:</h4>
      <p>The VCA trimmer to get the gain you want. As the soft clipping voltage is fixed this defines at which point of the knob turn (or CV) pushes the signal into clipping. It's up to you how much clipping you want! I like to set it to start at 12 O'Clock (~2.5V CV)</p>
      
      <p>The VCF trimmer is used to tune the V/Oct response and effective range of the filter. I like to tune it by putting the filter into self-oscilation and applying CVs octaves apart (0,1,2,3 V) and adjust the tone until the tones are octaves apart. 
        Repeat for a bunch of frequency knob positions until you're happy with overall tracking.
      </p>
    </Col>
    </Row>
    

    </Col>

  <Row style={{margin:"4rem"}}></Row>



</>
}

export default RRBuild